import { CitationOfficerDto } from './citationOfficerDto';
import { CitationPhotoDto } from './citationPhotoDto';

export interface CitationDto {
    id?: number;
    number?: string | null;
    locationId?: number;
    locationCode?: string | null;
    locationName?: string | null;
    locationTimeZoneId?: string | null;
    plate?: string | null;
    state?: string | null;
    violation?: string | null;
    ticketId?: number | null;
    ticketEndUtc?: string | null;
    observedAtUtc?: string | null;
    issuedAtUtc?: string | null;
    issuedBy?: CitationOfficerDto | null;
    notes?: string | null;
    status?: string | null;
    voidReason?: string | null;
    voidedAtUtc?: string | null;
    voidedBy?: CitationOfficerDto | null;
    officerVoidDeadlineUtc?: string | null;
    photoCount?: number;
    photos?: Array<CitationPhotoDto> | null;
}
